let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1zUjn")).then(() => parcelRequire('7ycLr'));